import type { UserDetailed } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getUserDetails(userId: string): Promise<UserDetailed> {
  return requestApiJsonOrThrow<UserDetailed>(`admin/users/${userId}`)
}

export const userDetailsQuery = (userId: string) => ({
  queryKey: ['user', userId],
  queryFn: () => getUserDetails(userId),
})

export const getFullNameUser = (user?: UserDetailed) => {
  const fName = `${user?.user?.givenName ?? ''} ${user?.user?.familyName ?? ''}`.trim()

  return fName.length > 0 ? fName : undefined
}
